import {
  REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/RemoveRowsConfirmationModali18nConstants';

export const REMOVE_ROWS_CONFIRMATION_MODAL_I18N_EN = {
  [REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS.modal_title]:                    "Remove rows with errors and proceed",
  [REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS.paragraph_1]:                    "Rows with errors in the content, date and source (if uploaded file contains the date and source column) will be removed. If the file does not have the source column, the file name will be used as the source.",
  [REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS.paragraph_2]:                    "Rows with errors in the source_link column will not be removed as it is an optional column.",
  [REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS.do_not_show_this_message_again]: "Do not show this message again",
  [REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS.cancel_button_text]:             "Back",
  [REMOVE_ROWS_CONFIRMATION_MODAL_I18N_KEYS.continue_button_text]:           "Continue"
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/remove_rows_confirmation_modal.i18n.en.js